module.exports = __webpack_public_path__ + "img/laksetartar.d2a6abd2.jpg";